<template>
    <div class="introduce-content">
        <div class="title" id="screeshots">-  Screenshots  -</div>
        <div class="pic-scroll">
            <img class="scroll-img" v-for="(item,index) in translist" :src="item" :key="index">
        </div>
        <div class="title" id="introduction">-  Introduction -</div>
        <div class="introduce-desc" v-for="(item,index) in config.introduceTitle" :key="index">
            {{ item }}
        </div>
        <template v-for="item in config.introduceText">
            <div class="introduce-title">{{ item.title }}</div>
            <div class="introduce-item" v-for="el in item.text">
                {{ el }}
            </div>
        </template>
        <div class="last-item"></div>
    </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import config from "../config.js";
export default {
    components: {
        swiper,
        swiperSlide
    },
    data() {
        return {
            config,
            translist: [
                require("@/assets/1.jpg"),
                require("@/assets/2.jpg"),
                require("@/assets/3.jpg"),
                require("@/assets/4.jpg"),
                require("@/assets/5.jpg"),
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
.introduce-content{
    padding-top: 80px;
    background: url(../assets/content-bg.jpg);
    background-size: cover;
    display: flex;
    flex-direction: column;
    align-items: center;
    .title{
        font-size: 50px;
        font-weight: 600;
        color: #000;
        margin-bottom: 20px;
    }
    .introduce-desc{
        font-size: 22px;
        font-weight: 500;
        text-align: center;
    }
    .introduce-title{
        margin-top: 20px;
        font-size: 22px;
        font-weight: 500;
    }
    .introduce-item{
        font-size: 22px;
    }
    .last-item{
        margin-bottom: 60px;
    }
    .pic-scroll{
        display: flex;
        flex-wrap: nowrap;
        width: 1350px;
        max-width: 1350px;
        height: 740px;
        margin-bottom: 80px;
        overflow-x: scroll;
        .scroll-img{
            width: 440px;
            height: 100%;
            margin-right: 10px;
        }
    }
}
@media screen and (max-width: 768px) {
    .introduce-content{
        .title{
            margin-top: 40px;
        }
        padding: 0 40px;
        .introduce-desc{
            text-align: center;
        }
        .introduce-item{
            text-align: center;
        }
        .pic-scroll{
            width: 650px;
            max-width: 650px;
        }
    }
}
</style>